var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.NotificationsAvailable &&
        _vm.NotificationPermission === 'default' &&
        !_vm.userPermissionGiven
      )?_c('v-list-item',{staticClass:"pa-0 chatConversation blue lighten-3",on:{"click":_vm.requestNotificationPermission}},[_c('v-list-item-content',[_c('div',{staticClass:"px-3 py-2"},[_c('v-avatar',{attrs:{"size":"50","color":"white"}},[_c('v-icon',{attrs:{"size":"30","color":"blue lighten-3"}},[_vm._v("fas fa-bell-slash")])],1),_c('span',{staticClass:"poppins-medium ml-4"},[_vm._v(_vm._s(_vm.$t("enableDesktopNotifications")))])],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }